import { render, staticRenderFns } from "./storeInSubmitToAction.vue?vue&type=template&id=b1434d24&scoped=true"
import script from "./storeInSubmitToAction.vue?vue&type=script&lang=js"
export * from "./storeInSubmitToAction.vue?vue&type=script&lang=js"
import style0 from "./storeInSubmitToAction.vue?vue&type=style&index=0&id=b1434d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1434d24",
  null
  
)

export default component.exports